/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_sq.js                                                                                */
/**********************************************************************************************************************/
/* Controller.SQ */

HafasWebapp.prototype.Controller.SQ = {
  stationMarker: null,
  additionalInstances: {},
  stopsNearby: [],
  currentShownNearStops: [],
  currentNearStopsFilter: [],
  currentNearStops: [],
  index: function (data) {
    var me = this;
    data = data || {};

    Hafas.bind(this.Controller.SQ.cleanup, this)();
    if (Hafas.Config.Switches.useFavorites) {
      this.Controller.Favorites.instance.checkDataConsistency();
      // Wenn allType Suche im Stationboard erlaubt ist, müssen die Favoriten nicht gefiltert werden
      if (Hafas.Config.SQ.allType) {
        var favorites = this.Controller.Favorites.instance.getData();
      } else {
        // getData(1): alle locations, die nicht vom Typ 1 (Station) sind,
        // erhalten den Wert display = false. Auf diesen wird im Template common.tabs.html gepr�ft
        var favorites = this.Controller.Favorites.instance.getData(1);
      }
    }

    if(Hafas.Modules.History)
      Hafas.Modules.History.addData("SQ", "index", {});

    // Model wird von AtomModel übernommen und erweitert.
    var model = {};

    if(Hafas.Config.SQ.useQueryOptions) {
      model.customerOptions = me.Controller.SQ.options.get();
      model.useOptions = true;
    }

    model.fltrL = me.Controller.SQ.fltrL;

    // TODO: Classic version ist in der Lyra nicht vertreten
    /**
     * Fuer die Classic-Version muss es konfigurierbar sein, ob die "Optionen" von vornherein angezeigt werden sollen
     * oder ob sie �ber den Link "Optionen" eingeblendet werden sollen
     * Aus der switches.tpl und der js_hafasconfig.tpl erhalten wir "showOptionsOnInit"
     */
    model.showOptionsOnInit = Hafas.Config.showOptionsOnInit;


    var useFavorites = Hafas.Config.Switches.useFavorites;
    if(Hafas.Config.SQ.allType == true){
      model.customerFavorites = useFavorites ? me.Controller.Favorites.instance.getData() : null;
      model.sqInputLabelText = Hafas.Modules.i18n.get('SQ.label.t_N_enterStopLocation');
    }else{
      model.customerFavorites = useFavorites ? me.Controller.Favorites.instance.getData(1): null;
      model.sqInputLabelText = Hafas.Modules.i18n.get('SQ.label.t_N_enterStop')
    }



    // Pr�fen ob Location gesetzt ist, und entsprechend im model vorbelegen:
    var currentLocation = me.Controller.SQ.instance.getLocation();
    if (currentLocation != null && typeof currentLocation.name != 'undefined') {
      model.stationInput = currentLocation.name;
      Hafas.bind(this.Controller.SQ.setLoactionMarker, this)(currentLocation);
    }

    // Todo: unsch�n, es muss in die renderengine eine methode, die auch ineinander verschachtelete templateresourcen rendern kann
    // Todo: zurzeit muss der Loader gerufen werden anstatt direkt auf die Renderengine zu gehen, nicht gut, aber l�uft
    Hafas.Core.newType("hafasLoader", {
      file: 'sq.index.html',
      tplId: 'SQ_TplIndex',
      callback: function (templateId) {
        Hafas.Modules.Render.render({
          target: me.formContainer,
          template: templateId,
          model: model
        }, function () {

          if (Hafas.Config.debug.showDataModel) {
            console.log('+++ SQ.index +++ DEBUG Model +++', model)
          }

          // Lade eventuell ge�nderte Optionen in die Formular-GUI
          var optionData = {
            context        : 'SQ'
          };
          Hafas.ps.pub('/options/setChangedOptionsInputForm', [optionData]);

          var sqSuggestConfig = Hafas.Core.clone(Hafas.Config.Suggest);
          if(Hafas.Config.SQ.allType) {
            sqSuggestConfig.suggestType = 'ALL';
          }else{
            sqSuggestConfig.suggestType = 'S';
          }
          var tmpLoc = me.Controller.SQ.instance.getLocation();
          me.Controller.SQ.inpStation = Hafas.Core.newType('hafasSuggest', {loc: "Station", config: sqSuggestConfig, type: "S", onSelect:function() {
              Hafas.ps.pub('/app/events/resize', [{}]);
            }});

          if (tmpLoc != null && tmpLoc.name) {
            me.Controller.SQ.inpStation.setLocation(tmpLoc);
          }
          else {
            // Instanz hat keinen Wert, gibt es ein StorageObjekt für dieses Feld?
            if (Hafas.ps.pub('/common/observe/inputvalues', ['get', me.Controller.SQ.inpStation.inp.id])) {
              me.Controller.SQ.inpStation.inp.value = Hafas.ps.pub('/common/observe/inputvalues', ['get', me.Controller.SQ.inpStation.inp.id]);
            }
          }

          Hafas.ps.pub('/options/init', [{context: "SQ"}]);

          // Autorefresh beim Aufruf der Eingabeseite immer zurücksetzen!!!
          me.Controller.SQ.instance.stopAutorefresh();

          // Vorbelegung "Anzahl Fahrten"
          var maxJnyBox = Hafas('[data-name="maxJourneys"]');
          // Wenn das Element vorhanden ist, dann
          if (maxJnyBox) {
            for (var g = 0; g < maxJnyBox.options.length; g++) {
              if (maxJnyBox.options[g].value == me.Controller.SQ.instance.getMaxJourneys()) {
                maxJnyBox.selectedIndex = g;
              }
            }
          }

              var historyDateTime = data.dateTime || {};
              var historyDate = historyDateTime.date;
              var historyTime = historyDateTime.time;
              var historyIsNowMode = historyDateTime.isNowMode;

              // if history wasn't created before, let stboard module decide how variables are set
              if(historyIsNowMode === undefined || historyIsNowMode === null)
                historyIsNowMode = me.Controller.SQ.instance.getTimeNow();
              if(historyDate === undefined || historyDate === null)
                historyDate = me.Controller.SQ.instance.getDate();
              if(historyTime === undefined || historyTime === null)
                historyTime = me.Controller.SQ.instance.getTime();

              // setting tdp-configuration
              var dateTimePickerConfig = {
                holder: "HFS_SqDateTimePickerHolder",
                id: "SQ_DTP",
                config: {
                  useDepArrSwitch: false
                },
                current: {
                  date: historyDate,
                  time: historyTime,
                  enquiry: true,
                  isNowMode: historyIsNowMode
                }
              };
              // set stboard module dateTime from history, if view is restored
              me.Controller.SQ.setDateTime(historyDate, historyTime, historyIsNowMode);
              me.Controller.SQ.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);

          // Favoriten als SegmentedControl
          if(Hafas.Config.showFavoriteBox === true) {
            Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_CustomerFavoritesWrap'}).initiate();
          }

          Hafas.ps.pub('/app/events/renderDone');

          // f�lle die UIActions des SQ-Moduls
          // Common_TplFormUIActions
          if (document.getElementById(me.formUIHiddenActions)) {
            Hafas.Modules.Render.render(
                {
                  file: 'common.partials.html',
                  target: me.formUIHiddenActions,
                  template: 'Common_TplFormUIActions',
                  model: {
                    appcontext: 'SQ'
                  }
                },
                function (html) {

                }
            );
          }

          // Überprüfe aktuelle Position
          if(Hafas.Config.SQ.allType) {
            Hafas.ps.pub('/apis/geolocation/check');
          }

          // Track
          Hafas.ps.pub('/tracking/screen/stationboard-planner-main', [ { typ: 'screen', key: 'stationboard-planner-main' } ]);
          Hafas.ps.pub('/tracking/screen/stationboard-main', [ { typ: 'screen', key: 'stationboard-main' } ]);

          Hafas.ps.pub('/GUI/form/show', [{}]);
          Hafas.ps.pub('/favorites/update');
          Hafas.ps.pub('/app/events/resize', [{}]);
          Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

          Hafas.bind(me.Controller.SQ.loadNearStops, me)();

          me.Controller.SQ.updateIndexHistory();
        });
      }
    });
  },

  initDirection          : function (data) {
    var model = this.Controller.SQ.options.getModelById('HFS_SQDirection');
    if(model != null && (Hafas("#HFS_Suggest_HFS_SQDirection") == null)) {
      this.Controller.SQ['inpDir'] = Hafas.Core.newType('hafasSuggest', {
        loc   : "HFS_SQDirection",
        config: Hafas.Config.Suggest,
        type  : "V"
      });
      this.Controller.SQ['inpDir'].setSuggestType("S");
    }
    var visibility = false;
    if(model.value != "") {
      visibility = true;
    }
    Hafas.ps.pub('/options/gui/toggle/delete', [{id: "HFS_SQDirection", visibility: visibility}]);
  },

  updateIndexHistory: function() {
    Hafas.Modules.History.addOrUpdateData('SQ', 'index', {
      dateTime: {
        date: this.instance.getDate(),
        time: this.instance.getTime(),
        isNowMode: this.instance.getTimeNow()
      }
    });
  },
  setDateTime: function(hciDate, hciTime, timeNow) {
    this.instance.setTime(hciTime);
    this.instance.setDate(hciDate);
    this.instance.setTimeNow(timeNow);
  },
  selectDateTimeFromPicker: function (hciDate, hciTime, dir, timeNow) {
    this.Controller.SQ.setDateTime(hciDate, hciTime, timeNow);
    this.Controller.SQ.updateIndexHistory();
  },
  setAllProducts: function (onOrOff)
  {
    var onBool = onOrOff == "on";
    var productList = Hafas.Util.products.getForContext("SQ");
    var options = { selectedProducts: [] };
    for (var i = 0; i < productList.length; i++)
    {
      var productClass = productList[i];
      this.Controller.SQ.instance.setProductClass(productClass.bit, onBool);
      options.selectedProducts.push({bit:productClass.bit, value:onBool});
    }
    this.Controller.SQ.options.setOptionModel(options);
  },
  getLocationsNear: function () {
    this.Controller.SQ.inpStation.getNearbyStops();
  },
  postForm: function (data) {
    if (typeof data.ev != 'undefined')
      data.ev.preventDefault();
    var me = this;

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');

    // close all open tabs
    Hafas.ps.pub('/GUI/tabs/closeAll');

    // Vorherige Auswahl aus der Karte löschen
    Hafas.bind(this.Controller.Map.closeToolbox,this)();

    // Vorherige Stops in der Nähe ausblenden sofern vorhanden:
    Hafas.bind(this.Controller.SQ.hideStopsNearby,this)();

    // Productfilter für Ergebnisse zurücksetzen
    this.Controller.SQ.instance.resetProductResultFilter();

    this.Controller.SQ.validate(['Station'], Hafas.bind(function () {
      var form = Hafas.Core.newType("hafasValidation", {
        form: data.form
      });
      if (form.valid) {
        // show loadingImage and set Button to disabled
        if (data.form.elements.submitSQForm) {
          Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitSQForm);
        }

        // Track
        Hafas.ps.pub('/tracking/event/stationboard-request', [ { typ: 'event', key: 'stationboard-request', data: {type: 'initial'} } ]);
        Hafas.ps.pub('/tracking/event/stationboard-request-triggered', [ { typ: 'event', key: 'stationboard-request-triggered', data: {type: 'initial'} } ]);

        this.Controller.SQ.instance.setSortType(Hafas.Config.SQ.sortType);
        this.Controller.SQ.instance.setTimeMode(Hafas.Config.SQ.timeInfoMode);

        Hafas.bind(this.Controller.SQ.resetResults, this)();
        this.Controller.SQ.instance.search();
        // Hafas.bind(this.Controller.SQ.showResult, this)
        // Hafas.bind(this.Controller.SQ.reRender, this);
      }
    }, this));

    Hafas.ps.pub('/app/events/resize');
    return false;
  },
  validate: function (data, callback) {
    var location = this.main.Controller.SQ.instance.getLocation();
    if (this.main.Controller.SQ.inpStation.getInputText().length == 0) {
      this.main.Controller.SQ.instance.setLocation(null);
    }
    if ((this.main.Controller.SQ.inpStation.getInputText().length > 0) && ((location == null) || (this.main.Controller.SQ.inpStation.getInputText() != location.name))) {
      this.main.Controller.SQ.inpStation.validateLocation(true, Hafas.bind(function () {
        data.shift();
        if (data.length > 0) {
          this.main.Controller.SQ.validate(data, callback);
        } else {
          callback();
        }
      }, this));
    } else {
      data.shift();
      if (data.length > 0) {
        this.main.Controller.SQ.validate(data, callback);
      } else {
        callback();
      }
    }
    return false;
  },
  resetResults: function () {

    var resultHolder = Hafas('#SQ_ResultOverview');
    if (resultHolder && resultHolder.childNodes.length !== 0) {
      this.Controller.SQ.instance.resetData();
      this.Controller.SQ.SegmentedControl.destroy();
      this.Controller.SQ.SegmentedControl = null;
      while (resultHolder.firstChild) {
        resultHolder.removeChild(resultHolder.firstChild);
      }
    }
  },

  /**
   * Oeffnet das Stationboard Ergebniss von einem anderen Context aus.
   * @param data
   * @param view <String> optional "info", "arr", "dep"
   */
  searchFromOtherContext: function (data, view) {

    view = view || "dep";
    Hafas.ps.pub('/app/switchContext', [{context: 'SQ', method: null}]);
      // PageContent muss wieder eingeblendet werden, da er zuvor im GUI Controller ausgeblendet wird
      if (this.layoutClass == "small") {
        Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), true);
      }

    Hafas.bind(this.Controller.SQ.resetResults,this)();

    Hafas.ps.pub('/app/events/resize');

    this.Controller.SQ.instance.setBoardType(view);
    this.Controller.SQ.instance.setLocation(data.location);

    if (Hafas.Config.Switches.useFavorites) {
      var type = Hafas.Util.location.getValueOfLid(data.location.lid,"type");
      var favIcon = null;
      if(typeof data.location.icnClass != 'undefined'){
        favIcon = data.location.icnClass;
      }else {
      switch(parseInt(type)){
          case 1:
            favIcon = 'haf_loc_halt';
            break;
          case 2:
            favIcon = 'haf_loc_adress';
            break;
          case 4:
            favIcon = 'haf_loc_poi';
            break;
        }
      }
      var depLocHistory = {name: data.location.name, lid: data.location.lid, prod: favIcon};
      this.Controller.Favorites.instance.addLocation(depLocHistory, 'History');
    }

    if(view === "info")
      this.Controller.SQ.instance.getInfo();
    else
      this.Controller.SQ.instance.search();
  },
  setLocation: function (loc) {

    var $inputEl = Hafas('#Station');
    if ($inputEl) {
      var newVal = !!loc ? loc.name : null;

      // only set value if it's different to the current one
      if ($inputEl.value !== newVal) {
        $inputEl.value = newVal;

        var label = Hafas('label[for="' + $inputEl.id + '"]');
        if (label)
          Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', { element: label.textContent, text: newVal }));
      }
    }

    Hafas.bind(this.Controller.SQ.setLoactionMarker, this)(loc);
  },

  /**
   * Setzt den SQ Marker auf die Karte und zoom die Karte da hin.
   * @param loc
   */
  setLoactionMarker: function(loc) {
    var mapController = this.Controller.Map;
    var mapInstance = mapController.instance;

    // Vorherigen Stationmarker entfernen
    Hafas.bind(this.Controller.SQ.removeStationMarker, this)();

    // Vorherige Stops in der Nähe ausblenden sofern vorhanden:
    Hafas.bind(this.Controller.SQ.hideStopsNearby,this)();

    // Vorherige Auswahl aus der Karte löschen
    Hafas.bind(this.Controller.Map.closeToolbox,this)();

    if (loc != null && loc.lid != undefined && Hafas.Config.Switches.useMap == true) {
      var tmpX = Hafas.Util.location.getValueOfLid(loc.lid, "x");
      var tmpY = Hafas.Util.location.getValueOfLid(loc.lid, "y");
      if(tmpX.length > 0 && tmpY.length > 0) {
        var crd = Hafas.Core.newType("hafasCCoord", {
          lon: tmpX,
          lat: tmpY
        });
      var markerTmpl = 'SELECTION';
      var params = {
        type: 'location',
        coord: crd,
        imageurl: Hafas.Util.getMarkerPath('DEFAULT_MARKER_URL_' + markerTmpl),
        imagewidth: Hafas.Config.Maps['DEFAULT_MARKER_URL_' + markerTmpl + '_WIDTH'],
        imageheight: Hafas.Config.Maps['DEFAULT_MARKER_URL_' + markerTmpl + '_HEIGHT'],
        hotspot: {
          x: Hafas.Config.Maps['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_X'],
          y: Hafas.Config.Maps['DEFAULT_MARKER_' + markerTmpl + '_HOTSPOT_Y']
        },
        priority: 10000,
        draggable: true,
        onDrag: function (coord, marker, map) {

        }
      };
      this.stationMarker = mapInstance.createContent(params);
      mapInstance.showContent(this.stationMarker);
      mapInstance.centerToContent(this.stationMarker, 14);
      mapInstance.currentPositionMarker = this.stationMarker;
    }
    }
  },
  removeStationMarker: function () {
    var mapController = this.Controller.Map;
    var mapInstance = mapController.instance;
    if (this.stationMarker != null) {
      mapInstance.hideContent(this.stationMarker);
      mapInstance.removeContent(this.stationMarker);
      this.stationMarker = null;
    }
  },
  isLocationFavorite: function (station) {
    // TODO: Wird diese Methode noch benötigt? Kann diese nun nicht über das Favoritenmodul erledigt werden?
    var isFavorite = false;
    // check if station is favorite
    var lId = station.lid,
            name = station.name,
            c = 0;
    if(Hafas.Config.SQ.allType){
      var favStoredLocations = this.Controller.Favorites.instance.getData().locations;
    }else{
      var favStoredLocations = this.Controller.Favorites.instance.getData(1).locations;
    }
    var cLen = favStoredLocations.length;
    for (c; c < cLen; c++) {
      var favLocLId = favStoredLocations[c].lid;
      var favLocName = favStoredLocations[c].name;
      if ((lId == favLocLId) || (name == favLocName)) {
        isFavorite = true;
      }
    }
    return isFavorite;
  },
  checkLocationFavorite: function (favElementClass) {
    // TODO: Wird diese Methode noch benötigt? Kann diese nun nicht über das Favoritenmodul erledigt werden?
    var element = Hafas(favElementClass);
    if (element != null) {

      // var currentResult = this.Controller.SQ.instance;
      // if(typeof currentResult.station != "undefined") {
      //   var isFavorite = Hafas.bind(this.Controller.SQ.isLocationFavorite, this)(currentResult.station);
      //
      //     if(isFavorite) {
      //       element.firstElementChild.removeClassName('haf_rating_star_button_inactive');
      //       element.firstElementChild.addClassName('haf_rating_star_button_active');
      //     } else {
      //       element.firstElementChild.removeClassName('haf_rating_star_button_active');
      //       element.firstElementChild.addClassName('haf_rating_star_button_inactive');
      //     }
      // }
    }
  },
  toggleLocationFavorite: function (locations) {
    // TODO: Wird diese Methode noch benötigt? Kann diese nun nicht über das Favoritenmodul erledigt werden?
    var _me = this;
    try {
      for (var j = 2; j < locations.length; j++) {
        // locations sollten im ersten Schritt nur zur History hinzugef�gt werden
        _me.Controller.Favorites.instance.addLocation(locations[j], 'History');
      }
      switch (locations[1]) {
        case 'station':
          var favoriteMarkerTarget = Hafas('[data-favorite-marker="sq"]', false);
          var favoriteMarkerData = {
            name: _me.Controller.SQ.instance.station.name,
            lid: _me.Controller.SQ.instance.station.lid
          };
          if (Hafas.bind(_me.Controller.SQ.isLocationFavorite, _me)(locations[2])) {
            var currentLocIdx = _me.Controller.Favorites.instance.getLocationIndex(locations[2]);
            _me.Controller.Favorites.instance.removeLocationFav(currentLocIdx);
            favoriteMarkerData.isFavorite = '_inactive';
          } else {

            var type = Hafas.Util.location.getValueOfLid(locations[2].lid,"type");
            var favIcon = null;
            switch(parseInt(type)){
              case 1: favIcon = 'haf_loc_halt';break;
              case 2: favIcon = 'haf_loc_adress';break;
              case 4: favIcon = 'haf_loc_poi';break;
            }
            locations[2].prod = favIcon;
            _me.Controller.Favorites.instance.addLocation(locations[2]);
            favoriteMarkerData.isFavorite = '_active';
          }
          Hafas.Modules.Render.render({
            file: 'sq.result.html',
            target: favoriteMarkerTarget,
            template: 'SQ_TplFavoriteMarker',
            model: favoriteMarkerData
          }, Hafas.bind(function () {

          }, this));
          break;
      }
    } catch (e) {
      console.log(e.toString());
    }
  },
  setDate: function (hciDate) {
    this.Controller.SQ.instance.setDate(hciDate);
    this.Controller.SQ.instance.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.setDate(hciDate);
    this.Controller.SQ.dateTimePicker.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.updateDisplay();
  },
  setTime: function (hciTime) {
    this.Controller.SQ.instance.setTime(hciTime);
    this.Controller.SQ.instance.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.setTime(hciTime);
    this.Controller.SQ.dateTimePicker.setTimeNow(false);
    this.Controller.SQ.dateTimePicker.updateDisplay();
  },
  changeStationboardTab    : function (data) {
    var newBoardType = data.trigger.getAttribute('data-sqtab');
    // Blende Button bei boardType Info aus
    Hafas.Util.gui.setVisibility(Hafas('#HFS_SQFilterSetBtn',false), (newBoardType !== 'info'));
    this.Controller.SQ.instance.setBoardType(newBoardType);
    if(!data.trigger.hasAttribute('data-changed') || data.trigger.getAttribute('data-changed') === 'true') {
      Hafas.bind(this.Controller.SQ.renderStationboardTabs,this)(true);
    }

    // Tracking
    if (typeof newBoardType !== 'undefined') {
      if (newBoardType === 'info') {
        Hafas.ps.pub('/tracking/screen/stationboard-overview-info', [ { typ: 'screen', key: 'stationboard-overview-info' } ]);
        Hafas.ps.pub('/tracking/screen/stationboard-overview', [ { typ: 'screen', key: 'stationboard-overview', data: {type: '-info'} } ]);
      }
      if (newBoardType === 'dep') {
        Hafas.ps.pub('/tracking/screen/stationboard-overview-departures', [ { typ: 'screen', key: 'stationboard-overview-departures' } ]);
        Hafas.ps.pub('/tracking/screen/stationboard-overview', [ { typ: 'screen', key: 'stationboard-overview', data: {type: '-departures'} } ]);
      }
      if (newBoardType === 'arr') {
        Hafas.ps.pub('/tracking/screen/stationboard-overview-arrivals', [ { typ: 'screen', key: 'stationboard-overview-arrivals' } ]);
        Hafas.ps.pub('/tracking/screen/stationboard-overview', [ { typ: 'screen', key: 'stationboard-overview', data: {type: '-arrivals'} } ]);
      }
    }

    // Pub fürs resize beim Loadingpanel
    Hafas.ps.pub('/app/events/resize');
  },
  changeStationboardOptions: function ( ) {
    var segCon = this.Controller.SQ.SegmentedControl.getState();
    if (segCon.buttons) {
      segCon.buttons.forEach(function (t) {
        t.setAttribute('data-changed', 'true');
      });
    }
  },
  renderStationboardTabs   : function (dataChanged) {
    var data;
    var template  = 'SQ_TplBoardContent';
    var me        = this;
    var boardType = this.Controller.SQ.instance.getBoardType();

    // Hole Daten & Setze Template
    if (boardType === 'info') {
      // Gibt Daten zurück oder schießt ein Pub dataChanged
      data = this.Controller.SQ.instance.getInfoData();
      template = 'SQ_TplInfoContent';
    }
    else {
      // Gibt Daten zurück oder schießt ein Pub dataChanged
      data = this.Controller.SQ.instance.getResultData();
    }
    // Sind die Daten da?
    if (!data) {
      // console.warn('keine Daten!');
      return;
    }


    // Ist das SegmentedControl schon aktiv? Wenn nicht mach erstmal weiter
    if (typeof this.Controller.SQ.SegmentedControl !== 'undefined' &&
        this.Controller.SQ.SegmentedControl !== null &&
        typeof this.Controller.SQ.SegmentedControl.getState === 'function') {
      var segCon = this.Controller.SQ.SegmentedControl.getState();
      // Wurde in zwischen Zeit ein anderer Tab aktiviert? Dann brich ab
      if (segCon && segCon.trigger && segCon.trigger.getAttribute('data-sqtab') !== boardType) {
        return;
      }
    }

    // Prüfe ob ResultOverview schon gerendert wurde, wenn nicht render.
    var resultHolder = Hafas('#SQ_ResultOverview');

    if (resultHolder && resultHolder.childNodes.length === 0) {
      Hafas.bind(this.Controller.SQ.showResult, this)(data);
      // console.warn('Komplette Resultseite wird neu geladen');
      return;
    }

    if (segCon && segCon.buttons && segCon.target) {
      // Sind die Daten neu?
      if (!dataChanged) {
        // Setze Attribut um neu zu rendern
        segCon.buttons.forEach(function (t) {
          t.setAttribute('data-changed', 'true');
        });
      }
      // Außer beim aktuellen Tab
      segCon.trigger.setAttribute('data-changed', 'false');

      // Render Daten in Tabpanel
      setTimeout(Hafas.Modules.Render.render({
        file    : 'sq.result.html',
        target  : segCon.target,
        template: template,
        model   : data
      }, function () {
        // Notiz: Callback wurde aus dem alten Render Callback übernommen (26.10.17)
        // remove loadingImage
        if (me.trigger) {
          if (me.triggerLoadingImage) {
            try {
              me.trigger.removeChild(me.triggerLoadingImage);
              delete me.triggerLoadingImage;
            }
            catch (e) {
              // do nothing
            }
          }
          me.trigger.removeAttribute('disabled');
        }

        // Hinzugefügt aus showInfo Callback (26.10.17)
        // TODO: Mit MGAB abklären was das hier ist:
        if(boardType === 'info') {
          // var container = Hafas('[data-stationinfo="map"]', false);
          // var newMap = Hafas.Core.newType('hafasMapLeaflet', container, {
          //   coord: data.crd,
          //   zoom: 15,
          //   reverseLookup: false,
          //   layer: [{
          //     "name": "HAFAS BaseLayer",
          //     "id": "HafasBaseMap",
          //     "type": "static",
          //     "url": Hafas.Config.staticTileURL,
          //     "attribution": "&copy; OpenStreetMap contributors",
          //     "isBaseLayer": true
          //   }]
          // });
        }

        // close all open tabs
        Hafas.ps.pub('/GUI/tabs/closeAll');

        // is defined in classic-Version GUI-Functions
        Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

        // Der "Unified Planner" gilt nur für TP, für SQ gibt es kein entsprechendes Konzept /mroe

        // Blende das Formular aus (Classic Version), aber nur wenn der Wert "TP.unifiedPlanner.show"
        // in der Config mit "false" deklariert ist
/*        if (!Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'SQ'}]);
        }*/

        Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'SQ'}]);

        Hafas.ps.pub('/GUI/results/overview/show', [{}]);

        // Neue Favoriten
        // if (Hafas.Config.showFavorites) {
        //   var favoriteMarkerTarget = Hafas('[data-favorite-marker="sq"]');
        //   Hafas.Modules.Render.render({
        //     file: 'sq.result.html',
        //     target: favoriteMarkerTarget,
        //     template: 'SQ_TplFavoriteMarker',
        //     model: favoriteMarkerData
        //   }, Hafas.bind(function () {
        //     Hafas.ps.pub('/app/events/grunticon');
        //   }, this));
        // }

        var optionData = {
          parentContainer: Hafas("[data-additional-info='result_sq']"),
          template       : 'Common_AtomTplOptionResInfo',
          context        : 'SQ'
        };

        Hafas.ps.pub('/options/setChangedOptionsInputForm', [optionData]);

        // Tracking
        var _sortType, _timeInfoMode;
        (me.Controller.SQ.instance.sortType === 'line') ? _sortType = 'grouped' : _sortType = 'chronological';
        (me.Controller.SQ.instance.timeInfoMode === 'countdown') ? _timeInfoMode = 'countdown' : _timeInfoMode = 'bytime';
        Hafas.ps.pub('/tracking/event/stationboard-overview-displayed', [ { typ: 'event', key: 'stationboard-overview-displayed', data: {type: _sortType + '+' + _timeInfoMode} } ]);

        Hafas.ps.pub('/GUI/results/resize', [{
          container : me.resultOverviewContainer,
          appcontext: me.appContext
        }]);
        Hafas.ps.pub('/app/events/resize');

        Hafas.Util.gui.resetScrollTop();

      }), 0.1);
    } else {
      // console.warn('Fehler beim Rendern!?',segCon && segCon.buttons && segCon.target);
    }
  },
  getStationboardTabs: function (currentMode) {
    // TODO: Diese Funktion soll über AtomModel abgewickelt werden. Daher prüfen wo diese noch vorkommt und schauen ob dort das AtomModel im Template eingesetzt werden kann.
    var stationboardModes = [];
    if (Hafas.Config.SQ.useDepartures) {
      if (currentMode == 'DEP') {
        var depActive = true;
      } else {
        var depActive = false;
      }
      stationboardModes.push({mode: 'DEP', active: depActive, label: Hafas.Modules.i18n.get('SQ.index.t_N_Departures')});
    }

    if (Hafas.Config.SQ.useArrivals) {
      if (currentMode == 'ARR') {
        var arrActive = true;
      } else {
        var arrActive = false;
      }
      stationboardModes.push({mode: 'ARR', active: arrActive, label: Hafas.Modules.i18n.get('SQ.index.t_N_Arrivals')});
    }
    return stationboardModes;
  },
  getFurtherJourneys: function () {
   var dateTime = this.Controller.SQ.instance.getFurtherJourneys();



    // nach oben scrollen (nur notwendig, wenn die Scrollbar nicht im Ergebniscontainer platziert ist
    if(Hafas.Config.verticalScrollbarPosition == 'window') {
      window.setTimeout(function () {
        Hafas('body').scrollTop = 0;
      }, 200);
    }

  },
  showResult: function (data) {
    // TODO: Diese Methode wird noch jedersmal bei neuen Daten aufgerufen.
    var me = this;

    if(Hafas.Modules.History)
      Hafas.Modules.History.addOrUpdateData("SQ", "result", data);

    // Übernahme aus verschiedenen Quellen // TODO: DATENKONSISTENZ!
    data       = data || {};
    var renderData = data.resolvedData || data || {};

    if(!Hafas.Config.Favorites.addLocationOnSuggest && Hafas.Modules.Suggest.getSuggestInstanceById('Station') !== null) {
      // wenn die Location nicht aus der SuggestList zur History hinzugef?gt werden soll, wird sie hier hinzugef?gt
      var prod = Hafas.Modules.Suggest.getSuggestInstanceById('Station').productRef;
      var name = me.Controller.SQ.instance.station.name;
      var lid = me.Controller.SQ.instance.station.lid;
      // location zu Verlauf hinzuf?gen
      me.Controller.Favorites.instance.addLocation({lid: lid, name: name, prod: prod}, 'History');
    }


    // check whether selected location is location favorite

    // Neue Favoriten? in Atom Model!

    // var favoriteMarkerData = {
    //   name: me.Controller.SQ.instance.station.name,
    //   lid: me.Controller.SQ.instance.station.lid
    // };

    // wenn die Location nicht aus der SuggestList zur History hinzugef?gt werden soll, wird sie hier hinzugef?gt
    // if (Hafas.Config.Switches.useFavorites && !Hafas.Config.Favorites.addLocationOnSuggest) {
    //   favoriteMarkerData.prod = Hafas.Modules.Suggest.getSuggestInstanceById('Station').productRef;
    //   // location zu Verlauf hinzuf?gen
    //   this.Controller.Favorites.instance.addLocation(favoriteMarkerData, 'History');
    // }

    // if (Hafas.Config.Switches.useFavorites) {
    //   var isFavorite = Hafas.bind(me.Controller.SQ.isLocationFavorite, me)(me.Controller.SQ.instance.station);
    //   if (isFavorite) {
    //     favoriteMarkerData.isFavorite = '_active';
    //   } else {
    //     favoriteMarkerData.isFavorite = '_inactive';
    //   }
    // }

    // show/hide Print-Icon
    // Im Template gibt es keine Abfrage auf showPrintIcon, daher auskommentiert (26.10.17
    // data.resolvedData.showPrintIcon = Hafas.Util.deviceCanPrint(); //-> true/false

    // get available board modes, pass current boardmode as parameter
    // var sqResultTpl = 'SQ_TplNoResults';
    // if (typeof data.resolvedData.emptyList == 'undefined' || !data.resolvedData.emptyList) {
    //   data.resolvedData.stationboardModes = me.Controller.SQ.getStationboardTabs(data.resolvedData.boardType.toUpperCase());
    //   sqResultTpl = 'SQ_TplResult';
    // }

    // Übernahme von Location aus der Map!
    if(renderData && !renderData.station_name && !renderData.locationId) {
      renderData.station_name = renderData.name;
      renderData.locationId = renderData.lid;
    }
    if (renderData && renderData.station_name && renderData.locationId) {
      var tmpLoc = {
        name: renderData.station_name,
        lid: renderData.locationId
      };
      me.Controller.SQ.instance.setLocation(tmpLoc);
      if(me.Controller.SQ.inpStation)
        me.Controller.SQ.inpStation.setLocation(tmpLoc);
    }
    // Neues SegmentedControl
    me.Controller.SQ.SegmentedControl = Hafas.Core.newType('HafasSegmentedControl', {
      holder  : 'HFS_SQResultSegCon',
      callback: Hafas.bind(me.Controller.SQ.changeStationboardTab,me)
    });

    renderData.timeInfoMode = me.Controller.SQ.instance.getTimeMode();
    renderData.sortType = me.Controller.SQ.instance.getSortType();
    renderData.boardType = me.Controller.SQ.instance.getBoardType().toLowerCase();

    // es kann beim History-Back vorkommen, dass der boardType "info" trotz Adresssuche übergeben wird
    // dann muss der boardType überschrieben werden, weil es sonst zu einem JS-Fehler kommt
    if((renderData.boardType == "info") && (data.resolvedData.useInfo == false)) {
      renderData.boardType = "dep";
    }

    window.setTimeout(Hafas.bind(function() {
    Hafas.Modules.Render.render({
      file: 'sq.result.html',
      target: 'SQ_ResultOverview',
      template: 'SQ_TplResult',
      model: renderData
    }, function () {

      // remove loadingImage
      if (me.trigger) {
        if (me.triggerLoadingImage) {
          try {
            me.trigger.removeChild(me.triggerLoadingImage);
            delete me.triggerLoadingImage;
          } catch (e) {
            // do nothing
          }
        }
        me.trigger.removeAttribute('disabled');
      }

      // close all open tabs
      Hafas.ps.pub('/GUI/tabs/closeAll');

      // is defined in classic-Version GUI-Functions
      Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

      // Der "Unified Planner" gilt nur für TP, für SQ gibt es kein entsprechendes Konzept /mroe
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'SQ'}]);

        // Blende das Formular aus (Classic Version), aber nur wenn der Wert "TP.unifiedPlanner.show"
        // in der Config mit "false" deklariert ist
        // if (!Hafas.Config.TP.unifiedPlanner.show) {
        //   Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'SQ'}]);
        // }

      Hafas.ps.pub('/GUI/results/overview/show', [{}]);


      var optionData = {
        parentContainer: Hafas("[data-additional-info='result_sq']"),
        template: 'Common_AtomTplOptionResInfo',
        context : 'SQ'
      };

      Hafas.ps.pub('/options/setChangedOptionsInputForm', [optionData]);

      Hafas.ps.pub('/GUI/results/resize', [{container: me.resultOverviewContainer, appcontext: me.appContext}]);
      Hafas.ps.pub('/app/events/resize');

      // SegmentedControl init+callback
      me.Controller.SQ.SegmentedControl.initiate();

      Hafas.Util.gui.resetScrollTop();
    });
    },this),1);

    // Es handelt sich um eine Adresse oder ein POI
    if(renderData.isLocation == true){
       var common = data.data.svcResL[0].res.common;
       Hafas.bind(me.Controller.SQ.showStopsNearby,me)(renderData.sortedByStops,common);
    }
  },
  showStopsNearby: function(stops,common){
    for(var s = 0; s < stops.length;s++) {
      var stopIcon = Hafas.Util.getImage(common.icoL[stops[s].icoX].res);
      var tmpMarker = Hafas.Util.maps.showHCILocation(stops[s], this.Controller.Map.instance, {
        imagewidth: Hafas.Config.Maps.DEFAULT_MARKER_WIDTH,
        imageheight: Hafas.Config.Maps.DEFAULT_MARKER_HEIGHT,
        imageurl: stopIcon,
        hotspot: {x: Hafas.Config.Maps.DEFAULT_MARKER_WIDTH/2 ,y:Hafas.Config.Maps.DEFAULT_MARKER_HEIGHT/2}
      },
      false, {selectable: true, priority: 50000000,common: common});
      this.Controller.SQ.stopsNearby.push(tmpMarker);
      this.Controller.Map.instance.centerToContent(this.Controller.SQ.stopsNearby);
    }
  },
  hideStopsNearby: function(){
      for(var s = 0; s < this.Controller.SQ.stopsNearby.length;s++){
        var tmpStop = this.Controller.SQ.stopsNearby[s];
        this.Controller.Map.instance.hideContent(tmpStop);
        this.Controller.Map.instance.removeContent(tmpStop);
      }
      this.Controller.SQ.stopsNearby = [];
  },
  getHeaderTitle: function(){
    var sqHeaderTitle = '';
    if(Hafas.Config.SQ.useDepartures && Hafas.Config.SQ.useArrivals){
      sqHeaderTitle = Hafas.Modules.i18n.get('SQ.index.t_N_Header');
    }else if(Hafas.Config.SQ.useDepartures){
      sqHeaderTitle = Hafas.Modules.i18n.get('SQ.index.t_N_Departures');
    }else if(Hafas.Config.SQ.useArrivals){
      sqHeaderTitle = Hafas.Modules.i18n.get('SQ.index.t_N_Arrivals');
    }
    return sqHeaderTitle;
  },
  toggleTimeMode: function (data) {
    if (typeof data.ev !== 'undefined')
      data.ev.preventDefault();

    // hide tabcontent in SQ Overview
    Hafas.ps.pub('/GUI/results/overviewSQ/tabbar/hide', [data]);


    if(typeof data.miniStboard == 'undefined' || data.miniStboard == false){
       var currentSqInstance = this.Controller.SQ.instance;
    } else {
       var currentSqInstance = this.Controller.SQ.additionalInstances['toolbox_' + data.extId];
    }

    if(typeof data.timeType != "undefined") {
      if(data.timeType == "time") {
        currentSqInstance.setTimeMode("time");
      }  else {
        currentSqInstance.setTimeMode("countdown");
      }
    } else {
    if (currentSqInstance.getTimeMode() == "time") {
      currentSqInstance.setTimeMode("countdown");
    } else {
      currentSqInstance.setTimeMode("time");
    }
    }    if(typeof data.miniStboard == 'undefined' || data.miniStboard == false) {
      Hafas.bind(this.Controller.SQ.changeStationboardOptions, this)(true);
      Hafas.bind(this.Controller.SQ.renderStationboardTabs,this)(true);
    } else {
      Hafas.bind(this.Controller.SQ.showMiniStboard,this)(data.extId);
    }
  },
  toggleSortType: function (data) {
    if (typeof data.ev !== 'undefined')
      data.ev.preventDefault();

    // hide tabcontent in SQ Overview
    Hafas.ps.pub('/GUI/results/overviewSQ/tabbar/hide', [data]);

    if(typeof data.miniStboard == 'undefined' || data.miniStboard == false){
      var currentSqInstance = this.Controller.SQ.instance;
    } else {
      var currentSqInstance = this.Controller.SQ.additionalInstances['toolbox_' + data.extId];
    }

    if(typeof data.sortType != "undefined") {
      if(data.sortType == "grouped") {
        currentSqInstance.setSortType("line");
      }  else {
        currentSqInstance.setSortType("time");
      }
    } else {
      if (currentSqInstance.getSortType() == "time") {
        currentSqInstance.setSortType("line");
      }
      else {
        currentSqInstance.setSortType("time");
      }
    }
    if(typeof data.miniStboard == 'undefined' || data.miniStboard == false) {
      Hafas.bind(this.Controller.SQ.changeStationboardOptions, this)(true);
      Hafas.bind(this.Controller.SQ.renderStationboardTabs,this)(true);
    } else {
      Hafas.bind(this.Controller.SQ.showMiniStboard,this)(data.extId);
    }
  },
  updateResultProductFilter: function(cls,trigger){
    var controllerSQ = this.Controller.SQ;

    if (trigger.getAttribute('aria-checked') === 'true') {
      filterStatus = false;
      trigger.setAttribute('aria-checked', 'false');
    } else {
      trigger.setAttribute('aria-checked', 'true');
      filterStatus = true;
    }
    this.Controller.SQ.instance.setProductResultFilter(cls,filterStatus);
    //this.Controller.SQ.reRender({});
    Hafas.bind(this.Controller.SQ.changeStationboardOptions, this)(true);
    Hafas.bind(this.Controller.SQ.renderStationboardTabs,this)(true);
  },
  closeView: function(histData) {
    switch(histData.view) {
      case "index":
        break;
      case "result":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
      case "options":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: false, view: 'options'}]);
        break;
      case "optionsDetails":
        histData.data.open = false;
        // Hafas.ps.pub('/GUI/options/details/toggle', [histData.data]);
        Hafas.ps.pub('/options/gui/toggle/group', [{groupId: 'HFS_SQProducts', target: 'HFS_SQProducts_Panel', view: 'optionsDetails', open: false}]);
        break;
    }
  },
  restoreView: function(histData) {
    var view = histData.view;
    switch(view) {
      case "index":
        Hafas.bind(this.Controller.SQ.index, this)(histData.data);
        break;
      case "result":
        Hafas.bind(this.Controller.SQ.showResult, this)(histData.data);
        break;
      case "options":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{target: 'HFS_CustomerOptionsWrap', open: true, view: 'options'}]);
        break;
      case "optionsDetails":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.ps.pub('/options/gui/toggle', [{open: true}]);
        histData.data.open = true;
        Hafas.ps.pub('/GUI/options/details/toggle', [histData.data]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderDefault'}]);
        break;
    }
  },
  stopAutorefresh: function (data) {
    // Stationboard Autofresh einstellen, wenn Applikation gewechselt wird
    if(typeof this.instance != 'undefined' && this.instance != null) {
      if (data == null || data.context != 'SQ') {
      this.instance.stopAutorefresh();
    }
    }
  },
  returnFromTrainRun: function(){
      if(this.main.appContext == 'SQ'){
         this.instance.search(Hafas.bind(this.main.Controller.SQ.showResult, this.main));
      }
  },
  cleanup: function () {
    Hafas.ps.pub('/options/gui/close/groups', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
    Hafas.bind(this.Controller.SQ.removeStationMarker, this)();
    Hafas.bind(this.Controller.SQ.hideStopsNearby,this)();
  },
  setGeoLocationPosition: function(locObj, inputId){
     this.Controller.SQ.instance.setLocation(locObj);
  },
  reRender: function (param) {
    if(typeof param.miniStboard == 'undefined' || param.miniStboard == false){
      var currentSqInstance = this.instance;
      var targetContainer = 'SQ_ResultOverview';
    }else{
      var currentSqInstance = this.additionalInstances['toolbox_' + param.extId];
      var targetContainer = Hafas('[data-toolbox-stationboard="' + param.extId + '"]',false);
      var filterOptions = Hafas('[data-toolbox-stationboard-filterbackground="' + param.extId + '"]',false);
      if(filterOptions){
         Hafas.Util.gui.setVisibility(filterOptions,false);
      }
    }

    // var data = currentSqInstance.getResults();
    // data.resolvedData.stationboardModes = this.getStationboardTabs(data.resolvedData.requestBoardType.toUpperCase());
    //
    // // Flyout Stationboard?
    // if(typeof param.miniStboard != 'undefined' && param.miniStboard == true){
    //   data.resolvedData.miniStboard = true;
    // }
    //
    // window.setTimeout(Hafas.bind(function() {
    // Hafas.Modules.Render.render({
    //   file: 'sq.result.html',
    //   target: targetContainer,
    //   template: 'SQ_TplResult',
    //   model: data.resolvedData
    // });
    // Hafas.ps.pub('/app/events/resize');
      Hafas.Util.gui.resetScrollTop();
    // },this),1);
  },
  toggleMiniStboard: function(show,location,options){
    try {
      if (typeof this.Controller.SQ.additionalInstances['toolbox_' + location.extId] == 'undefined') {
      var miniStboardParams = {
        id: 'toolbox_' + location.extId,
          station: {extId: location.extId,name: location.name},
        showJourneys: Hafas.Config.SQ.toolboxCfg.maxJourneys,
        sortType: Hafas.Config.SQ.setSortType,
        timeInfoMode: Hafas.Config.SQ.timeInfoMode,
        autorefresh: false,
        sort: 'PT'
      };
      if(typeof options != 'undefined'){
        if(typeof options.pCls != 'undefined') {
          miniStboardParams.prodclasses = options.pCls;
        }
        if(typeof options.sortType != 'undefined') {
          miniStboardParams.sortType = options.sortType;
        }
        if(typeof options.showLineSeparator != 'undefined') {
          miniStboardParams.showLineSeparator = options.showLineSeparator;
        }
      }
      this.Controller.SQ.additionalInstances['toolbox_' + location.extId] = Hafas.Core.newType("hafasStboard",miniStboardParams);
      Hafas.ps.sub('/sq/dataChanged/toolbox_' + location.extId, Hafas.bind(this.Controller.SQ.showMiniStboard,this,location.extId,options));
      this.Controller.SQ.additionalInstances['toolbox_' + location.extId].search();
    }else{
      Hafas.ps.unsub('/sq/dataChanged/toolbox_' + location.extId);
      delete this.Controller.SQ.additionalInstances['toolbox_' + location.extId];
    }
    }catch(e){

    }
  },
  toggleInfoDetails: function (data) {

    // TODO: Prüfen ob diese Funktion gebraucht wird, wenn ja barrierefrei gestalten.

    var $list, expandIcon;

    $list = Hafas('[data-infoList-id="' + data.expandId + '"]', false);
    expandIcon = Hafas('[data-infoList-expandarrow-idx="' + data.expandId + '"]', false);

    if ($list.classList.contains('close')) {
      $list.classList.remove('close');
      expandIcon.removeClassName('haf_ic_expand');
      expandIcon.addClassName('haf_ic_collapse');

      $list.classList.add('open');

    } else if ($list.classList.contains('open')) {
      $list.classList.remove('open');
      expandIcon.removeClassName('haf_ic_collapse');
      expandIcon.addClassName('haf_ic_expand');
      $list.classList.add('close');
    }


  },
  showMiniStboard: function(extId,options){
    var me        = this;
    this.Controller.SQ.instance.setBoardType('DEP');
    // Hole Daten & Setze Template
    var data = this.Controller.SQ.additionalInstances['toolbox_' + extId].getResultData();
    // Sind die Daten da?
    if (!data) {
      // console.warn('keine Daten!');
      return;
    }

    // Filtereinstellungen verstecken
    // var filterSettings = Hafas('[data-toolbox-stationboard-filterbackground="' + extId + '"]',false);
    // if(filterSettings){
    //   Hafas.Util.gui.setVisibility(filterSettings,false);
    // }

    var targetContainer = Hafas('[data-toolbox-stationboard="' + extId + '"]',false);
    var template  = 'SQ_TplResult';

    data.miniStboard = true;
    if(typeof options !== 'undefined'){
      for(var o in options){
        data.resolvedData[o] = options[o];
      }
    }

    // Render Daten in Tabpanel
    setTimeout(Hafas.Modules.Render.render({
      file    : 'sq.result.html',
      target  : targetContainer,
      template: template,
      model   : data
    }, function () {

    }), 0.1);

    Hafas.Util.gui.setVisibility(Hafas('[data-toolbox-stationboard-filterbackground="' + extId + '"]',false),false);
  },
  loadNearStops: function(){
    var me = this;
    if(Hafas.Config.SQ.useSmartDeparture) {
      Hafas.Util.getGeoLocation(function (geoLocationResponse) {
        var lat = parseInt(geoLocationResponse.coords.latitude * 1000000);
        var lon = parseInt(geoLocationResponse.coords.longitude * 1000000);
        me.Controller.SQ.showNearbyStops(lat, lon);
      }, function (data) {
        me.Controller.SQ.renderStopsNearby([]);
      });
    }
  },
  showNearbyStops: function(lat, lon){
    // Suche Linien
    var prodfilter = 0;
    for(var s=0; s < this.currentNearStopsFilter.length;s++){
      prodfilter += this.currentNearStopsFilter[s];
    }
    // Produktfilter wird hier absichtlich auf "0" gesetzt, damit alle Produkte abgeholt werden
    this.instance.searchNearbyStops({callback: Hafas.bind(function(stopList) {
      this.currentNearStops = stopList;
      this.renderStopsNearby(this.currentNearStops);
    }, this), coord:{lat:lat, lon:lon}, prodfilter:  0 });
  },
  renderStopsNearby: function(stopList){
    var showStopList = [];
    var maxStops = Hafas.Config.SQ.maxStopsNear || 999999;
    var activeBits = 0;
    for(var f=0; f < this.fltrL.length;f++){
      if(this.fltrL[f].active) {
        activeBits += this.fltrL[f].bit;
      }
    }
    var addedStops = 0;
    for(var i = 0; i < this.main.Controller.SQ.currentNearStops.length; i++)
    {
      var stop = this.main.Controller.SQ.currentNearStops[i];
      var useStop = false;
      if(activeBits != 0) {
        for (var p = 0; p < stop.pRefLResolved.length; p++) {
          if((stop.pRefLResolved[p].cls & activeBits) == stop.pRefLResolved[p].cls){
            useStop = true;
            break;
          }
        }
      }else{
        useStop = true;
      }
      if(useStop && addedStops < maxStops) {
        stop.isFav = Hafas.bind(this.main.Controller.SQ.isLocationFavorite, this.main)(stop);
        stop.idxResolved = addedStops;
        showStopList.push(stop);
        addedStops++;
      }
    }

    this.currentShownNearStops = showStopList;

    if (Hafas('#HFS_NearbySQ', false)) {
      var model = {
        stopList: showStopList,
        fltrL: this.fltrL
      };
      Hafas.Modules.Render.render({
        target  : 'HFS_NearbySQ',
        template: 'SQ_AtomTplStopsNearby',
        model   : model
      },function(html){
        Hafas.ps.pub('/app/events/resize');
      });
    }
  },
  selectStopFromNearList: function(index){
    var location = this.Controller.SQ.currentShownNearStops[index];
    this.Controller.SQ.instance.setLocation({name: location.name, lid: location.lid});
    this.Controller.SQ.instance.resetData();
    Hafas.bind(this.Controller.SQ.resetResults, this)();
    this.Controller.SQ.instance.search(Hafas.bind(this.Controller.SQ.showResult, this));
  },
  setProductFormFilter: function (bit, trigger) {
    var filterItem = Hafas.Util.array.getEntryByPropertyValue(this.Controller.SQ.fltrL, 'bit', bit);
    this.Controller.SQ.fltrL[filterItem.index].active = !trigger.getAttribute('aria-checked');

    var filterBits = [];
    var prodIdx = 0;
    var controllerSQ = this.Controller.SQ;
    for (var i = 0; i < controllerSQ.fltrL.length; i++) {
      if (controllerSQ.fltrL[i].bit == bit) {
        prodIdx = i;
      }
    }
    // change data model
    // if (trigger.getAttribute('aria-selected') === 'true') {
    //   controllerSQ.fltrL[prodIdx].active = false;
    //   trigger.setAttribute('aria-selected', 'false');
    // } else {
    //   controllerSQ.fltrL[prodIdx].active = true;
    //   trigger.setAttribute('aria-selected', 'true');
    // }
    for (var i = 0; i < controllerSQ.fltrL.length; i++) {
      if (controllerSQ.fltrL[i].active) {
        filterBits.push(controllerSQ.fltrL[i].bit);
      }
    }
    controllerSQ.currentNearStopsFilter = filterBits;
    //Hafas.bind(controllerSQ.loadNearStops,this)();
    Hafas.bind(this.Controller.SQ.renderStopsNearby,this.Controller.SQ)();
  },

  printSearchLink: function() {
    console.log(this.Controller.SQ.instance.createSearchLink());
  },

  addStopToFav: function(data){
     var tmpFav = Hafas.Modules.Favorites.getInstances();
     // locations sollten im ersten Schritt nur zur History hinzugefügt werden
     this.Controller.Favorites.instance.addLocation(data, 'History');
     this.Controller.Favorites.instance.addLocation(data);
  },
  removeStopFromFav: function(data){
    var currentLocIdx = this.Controller.Favorites.instance.getLocationIndex(data);
    this.Controller.Favorites.instance.removeLocationFav(currentLocIdx);
  },
  rerenderLinesNearby: function(){
      this.Controller.SQ.renderStopsNearby(this.Controller.SQ.currentNearStops);
  }
};
